export default __webpack_public_path__ + "static/media/education.70283067.svg";